import { connect } from 'react-redux';
import get from 'lodash/get';
import View from './AdvTopLevelWorkflowView';
import {
  initializeSection,
  fetchData,
  resetWorkflow,
  jump,
  save,
  randomAccessJump,
  popIteratorFromHistoryStack,
} from './AdvWorkflowActions';
import {
  currentClientId,
  workflowSubdivision,
  isAnyStepVisibleSelector,
  isPopulatedSelector,
  iterator as iteratorSelector,
  isInSummarySelector,
  jumpTypeSelector,
  canGoBackSelector,
  isInSummaryEditSelector,
  NO_WORKFLOW,
  DEFAULT_WORKFLOW,
} from './AdvWorkflowSelector';
import { ITERATOR_POST_END } from './AdvWorkflowHelpers';
import { initialize } from './AdvWorkflowCacheActions';
import { successAppVariablesRequest } from '../../ConsumerArea/ConsumerAreaActions';
import { updateConsumerAreaGlobalContext } from '../../ConsumerArea/utils/updateConsumerAreaGlobalContext';

const mapStateToProps = (state, ownProps) => ({
  workflowSubdivision: workflowSubdivision(state, ownProps),
  currentClientId: currentClientId(state, ownProps),
  isAnyStepVisible: isAnyStepVisibleSelector(state, ownProps),
  iterator: iteratorSelector(state, ownProps),
  isPopulated: isPopulatedSelector(state, ownProps),
  isInSummary: isInSummarySelector(state, ownProps),
  jumpType: jumpTypeSelector(state, ownProps),
  canGoBack: canGoBackSelector(state, ownProps),
  workflowId: ownProps.workflowId,
  goToSummaryWhenReady: ownProps.goToSummaryWhenReady,
  outputFunction: ownProps.outputFunction,
  onLastStepResponseListener: ownProps.onLastStepResponseListener,
  isInSummaryEdit: isInSummaryEditSelector(state, ownProps),
  selectedGoalId: ownProps.selectedGoalId,
});
const mapDispatchToProps = dispatch => ({
  advanceToLastViewedStep: (workflowId, clientId) => {
    dispatch(popIteratorFromHistoryStack(workflowId, clientId));
  },
  advanceToFirstStep: (workflowId, clientId) => {
    dispatch(jump(1, workflowId, clientId));
  },
  advanceToLastStep: (workflowId, clientId) => {
    dispatch(randomAccessJump(workflowId, clientId, ITERATOR_POST_END));
    dispatch(jump(-1, workflowId, clientId));
  },
  advanceToSummary: (workflowId, clientId) => {
    dispatch(randomAccessJump(workflowId, clientId, ITERATOR_POST_END));
  },
  initializeSection: (workflowId, clientId) => {
    dispatch(initialize());
    dispatch(initializeSection(workflowId, clientId));
  },
  saveAndQueryForNextAction: async (
    workflowId,
    clientId,
    storeLastStepResponse,
    storeCanGoToPlan,
    storeCanGoToAccounts,
  ) => {
    const onSuccess = async lastStepResponse => {
      if (!window.ADV.util.env('isConsumerArea')) {
        storeLastStepResponse(lastStepResponse);
        storeCanGoToPlan(true, lastStepResponse);
        storeCanGoToAccounts(true, lastStepResponse);
        return;
      }
      const response = await window.ADV.util.request({
        uri: 'Consumer/Consumer/GetApplicationVariables',
        data: {
          isPresentationMode: window.ADV.info.isPresentationMode,
          completedWorkflow: true,
          clientId,
        },
        showSpinner: true,
      });
      if (response.success) {
        dispatch(successAppVariablesRequest(response.payload.viewData));

        const variables = response.payload.viewData.ConsumerAreaContext;

        updateConsumerAreaGlobalContext({
          onboardingWorkflow: variables.ConsumerAccessWorkflow,
          modulesToHide: variables.ModulesToHide,
          optOuts: variables.OptOuts,
          featureFlags: variables.FeatureFlags,
          componentName: variables.ComponentName,
        });
      }

      if (get(lastStepResponse, 'success', false)) {
        storeLastStepResponse(lastStepResponse);
      }
      storeCanGoToPlan(
        get(response, 'payload.viewData.ConsumerAreaContext.OptOuts', []).reduce(
          (acc, optout) => (optout === 'TakeToFinancialPlan' ? false : acc),
          get(
            response,
            'payload.viewData.ConsumerAreaContext.ConsumerAccessWorkflow',
            DEFAULT_WORKFLOW,
          ) === NO_WORKFLOW,
        ),
        lastStepResponse,
      );
      storeCanGoToAccounts(
        get(response, 'payload.viewData.ConsumerAreaContext.OptOuts', []).reduce(
          (acc, optout) => (optout === 'TakeToAccounts' ? false : acc),
          get(
            response,
            'payload.viewData.ConsumerAreaContext.ConsumerAccessWorkflow',
            DEFAULT_WORKFLOW,
          ) === NO_WORKFLOW,
        ),
        lastStepResponse,
      );
    };
    const onFailure = () => {
      const { ADV } = window;
      throw Error(ADV.settings.MsgLib.generic_error);
    };
    dispatch(save(null, onSuccess, onFailure, workflowId, clientId, true));
  },
  save: (outputFunction, workflowId, clientId) => {
    dispatch(
      save(
        null,
        outputFunction,
        () => {
          const { ADV } = window;
          throw Error(ADV.settings.MsgLib.generic_error);
        },
        workflowId,
        clientId,
        true,
      ),
    );
  },
  resetWorkflow: selectedGoalId => dispatch(resetWorkflow(selectedGoalId)),
  fetchData: (workflowId, clientId) => {
    dispatch(fetchData(workflowId, clientId, [], true));
  },
  onFinish: (clientId, hasTakeMeToPlan) => () => {
    // The finish action can take us back to the all goals or display workflow done.
    // The finish action doesn't go to the
    // financial plan, that's why `Take me to my plan` button exists.
    window.ADV.util.Router.go2(hasTakeMeToPlan ? 'ClientEditPlan' : 'WorkflowDoneV2', {
      clientId,
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
